import { create, update } from "lodash";

export const URLS = {
  // BASE_URL: "http://192.168.100.30:8080/api/",
  BASE_URL: "https://rullier.api.ova-consulting.fr/api/",
  // BASE_URL: "http://192.168.100.12:8000/api/",
  //BASE_URL: "https://test.ovasourcing.ova-consulting.fr/api/",
   //CLIENT_ID: "YOL6YE1L1JJbuq8AtyX6iLeVSvmGFzWRS45Dr4u6",
  //CLIENT_ID: "0En4s1emUqHjhij9P5cHFFg7JbLQLdWKUXef0Xhl",
  PRODUCT_URL: "https://rullier-preprod.ova-consulting.fr/",
  
  AUTHS: {  
    // LOGIN: "auth/mlogin/",
    LOGIN: "auth/magento/oauth/",
    // REFRESH: "token/refresh/",
    REFRESH: "api/token/refresh/",
    LOGOUT: "auth/logout/",
    google: "auth/google/",
    REGISTRATION: "accounts/registration/",
    MANAGER_REGISTRATION: "accounts/staff/registration/",
    VERIFY_EMAIL: (key) => `accounts/accounts/confirm-email/${key}/`,
    VERIFY_ACCOUNT: (id) => `/users/verify/${id}/`,
    resetPassword: "accounts/password-reset/",
    resetPasswordAdmin: "accounts/password/admin-reset/",
    me: "users/me/",
    PASSWORD: {
      reset: "auth/password/reset/",
      confirm: "auth/password/reset/confirm/",
    },
    VERIFY: {
      email: "/accounts/email/verification/",
      resend: "/user/accounts/resend-email/",
    }
  },

  // Creating a project
  PROJECT:{
    createProject: "project/",
    details: (id) => `/project/${id}/`,
    getSteps: 'project/step/',
    createStep: '/project/step/',
    deleteStep: (id) => `/project/step/${id}/`,
    updateStep: (id) => `/project/step/${id}/`,
    createContent: 'project/content/',
    addContentProducts: 'project/sections/add-content-products/',
    removeContentProduct: (sectionId, productId) => `project/sections/${sectionId}/remove-content-product/${productId}/`,
    removeContentProductById: (id) => `/project/content_product/${id}/`,
    choiceLinkProducts: (id) => `/project/choice-item/${id}/link-products/`,
    updateInput: (inputId) => `project/inputs/${inputId}/`,
    updateSection: (sectionId) => `project/sections/${sectionId}/`,
  },

  PRODUCT:{
    getProduct: (query, page) => {
      const normalizedQuery = typeof query === "string" ? query.trim() : "";
      const encodedPage = Number.isFinite(Number(page)) && Number(page) > 0 ? Number(page) : 1;
      const pageParams = `page_size=10&page=${encodeURIComponent(encodedPage)}`;

      if (!normalizedQuery) {
        return `product/?${pageParams}`;
      }

      const encodedQuery = encodeURIComponent(normalizedQuery);
      return `product/?search=${encodedQuery}&${pageParams}`;
    },
    getAllProducts: () => 'product/',
    getProductById: (id) => `product/${id}/`
  },
  MEDIA: {
    productImage: (imageUrl) => `media/catalog/product/${imageUrl}/`
  },

  // Quotes
  QUOTE: {
    list: 'quote/',
    details: (id) => `quote/${id}/`,
  },

  //Bureau d'Etude
  BE:{
    PROJECT:{
      create: '/be/admin/projets/',
      list: '/be/admin/projets/',
      delete: (id) => `/be/admin/projets/${id}/`,
      details: (id) => `/be/admin/projets/${id}/`,
      update: (id) => `/be/admin/projets/${id}/`,
    },
    STEPS:{
      create: '/be/admin/steps/',
      getStepsByProject: (id) => `/be/admin/steps/?project=${id}`,
      list: (search) => `/be/admin/steps/?search=${search}`,
      update: (id) => `/be/admin/steps/${id}/`,
      deleteStep: (id) => `/be/admin/steps/${id}/`,
      details: (id) => `/be/admin/steps/${id}/`,
    },
    SECTIONS:{
      create: '/be/admin/sections/',
      update: id => `/be/admin/sections/${id}/`,
      delete: id => `/be/admin/sections/${id}/`
    },
    CHOICES:{
      create: '/be/admin/choices/',
      update: (id) => `/be/admin/choices/${id}/`,
      details: (id) => `/be/admin/choices/${id}/`,
    },
    CONTENTS:{
      create: '/be/admin/contents/',
      list: (search) => `/be/admin/contents/?search=${search}`,
      update: (id) => `/be/admin/contents/${id}/`,
      deleteContent: (id) => `/be/admin/contents/${id}/`,
      details: (id) => `/be/admin/contents/${id}/`,
    },
  }
  
}
 {/*} DASHBOARD: {
    list: "dashboard/user/"
  },
  CONFIGS: {
    PROFILE: {
      SKILLS: {
        create: "detail/skill/",
        list: (search) => `detail/skill/?search=${search}`,
        update: (id) => `detail/skill/?${id}`,
      },
      COLLEGE: {
        create: "detail/profile/college/",
        list: (search) => `detail/profile/college/?search=${search}`,
      },
      COMPANY: {
        create: "detail/profile/company/",
        list: (search) => `configs/profile/company/?search=${search}`,
      },
      SECTOR: {
        create: "detail/profile/industry/",
        list: (search) => `detail/profile/industry/?search=${search}`,
      },
      COUNTRIES: {
        CITIES: {
          list: (search) => `detail/profile/countries/cities/?search=${search}`,
          cmr: (search) => `detail/profile/villes/?search=${search}&limit=500`,
        },
        list: (search) => `detail/profile/industry/?search=${search}`,
      },
      DIPLOMA: {
        create: "detail/profile/diploma/",
        list: (search) => `detail/profile/diploma/?search=${search}`,
      },
      PERMIT: {
        create: "detail/permis/",
        list: (search) => `detail/permis/?search=${search}`,
        update: (id) => `detail/permis/?${id}`,
      },
      CERTIFICATION: {
        create: "detail/certifications/",
        list: (search) => `detail/certifications/?search=${search}`,
        update: (id) => `detail/certifications/?${id}`,
      },
      LANGUAGE: {
        create: "detail/language/",
        list: (search) => `detail/language/?search=${search}`,
        update: (id) => `detail/language/?${id}`,
      },
      EXPERIENCE: {
        create: "detail/work-experience/",
        list: (search) => `detail/work-experience/?search=${search}`,
        update: (id) => `detail/work-experience/?${id}`,
      },
      EDUCATION: {
        create: "detail/education/",
        list: (search) => `detail/education/?search=${search}`,
        update: (id) => `detail/education/?${id}`,
      }
    }
  },
  USERS: {
    APPLICATIONS: {
      myApplications: (search, page) => `users/my_applications/?search=${search}&page=${page}`,
    },
    PROFILE: {
      my: "users/my_profiles/",
      create: "users/profile/",
      list: (search, page) => `users/profile/?search=${search}&page=${page}`,
      myProfiles: (search, page) => `users/my_profiles/?search=${search}&page=${page}`,
      update: (id) => `users/profile/${id}/`,
      details: (id) => `users/profile/${id}/`,
      EDUCATION: {
        create: "users/profile/education/",
        update: (id) => `users/profile/education/${id}/`,
        details: (id) => `users/profile/education/${id}/`,
      },
      EXPERIENCE: {
        create: "users/profile/experience/",
        update: (id) => `users/profile/experience/${id}/`,
        details: (id) => `users/profile/experience/${id}/`,
      },
      CERTIFICATION: {
        create: "users/profile/certification/",
        update: (id) => `users/profile/certification/${id}/`,
        details: (id) => `users/profile/certification/${id}/`,
      },
      LANGUAGES: {
        create: "users/profile/language/",
        update: (id) => `users/profile/language/${id}/`,
        details: (id) => `users/profile/language/${id}/`,
      },
      REFERENCE: {
        create: "users/profile/reference/",
        update: (id) => `users/profile/reference/${id}/`,
        details: (id) => `users/profile/reference/${id}/`,
      },
      setAsDefault: (id) => `users/profile/${id}/set_as_default/`,
    },
    update: (id) => `users/${id}/`,
  },
  JOBS: {
    list: (search) => `/jobs/?search=${search}/`,
    history: (search) => `/jobs/history/?search=${search}/`,
    details: (id) => `/jobs/${id}/`,
    historyDetails: (id) => `/jobs/history/${id}/`,
    apply: (id) => `/jobs/${id}/apply/`,
    byCategory: (categoryId) => `/jobs/?industry=${categoryId}/`,
    byIndustry: (name) => `/jobs/?industry_name=${name}/`,
    search: (page, search, category, location) => `/jobs/?page=${page ?? 1}&search=${search ?? ""}${category ? '&industry__id=' + category : ''}${location ? '&city__name=' + location : ''}`,
    APPLICATIONS: {
      details:  (id) => `jobs/applications/${id}/`,
      cancel: (id) => `jobs/applications/${id}/cancel/`,
      accept: (id) => `jobs/applications/${id}/accept/`,
    },
    ANSWERS: {
      create: `jobs/related_question_answer/`,
    }
  },
  NOTIFICATIONS: {
    messages: (search, page) => `notifications/messages/?search=${search}page=${page ?? 1}`,
    details: (id) => `notifications/messages/${id}/`
  },
  NEWSLETTER: {
    SUBSCRIPTION: {
      create: "newsletter/subscriptions/",
      list: "newsletter/subscriptions/",
    }
  }
}  */}